import { fg } from '@confluence/feature-gating';

import { getCohortValue } from '../utils/check-experiment-data';
import { NOT_ENROLLED } from '../package-constants';

import { useFetchUpgradeStatusForFree } from './useFetchUpgradeStatusForFree';

export const useExperimentEnrollment = () => {
	// In order to avoid making unnecessary gql calls for default override groups in Statsig,
	// we will want to make a preliminary check to ensure they also fall into our audience criteria
	const cohort = getCohortValue();
	const isInExperiment = cohort != NOT_ENROLLED;

	const { userCanUpgrade } = useFetchUpgradeStatusForFree({
		skip: !isInExperiment || !fg('luna-confluence-recommend-to-free-ab'),
	});

	const isEnrolled = isInExperiment && userCanUpgrade && fg('luna-confluence-recommend-to-free-ab');

	return {
		cohort,
		isEnrolled,
	};
};
